import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M45 11.484c0-2.2-1.71-3.984-3.818-3.984-2.109 0-3.818 1.784-3.818 3.984v23.532c0 2.2 1.71 3.984 3.818 3.984S45 37.216 45 35.016V11.484Zm-3.818-1.992c-1.055 0-1.91.892-1.91 1.992v23.532c0 1.1.855 1.992 1.91 1.992 1.054 0 1.909-.892 1.909-1.992V11.484c0-1.1-.855-1.992-1.91-1.992Zm-7.637 9.867c0-2.2-1.709-3.984-3.818-3.984-2.108 0-3.818 1.784-3.818 3.984v15.657c0 2.2 1.71 3.984 3.818 3.984 2.109 0 3.818-1.784 3.818-3.984V19.359Zm-3.818-1.992c-1.054 0-1.909.892-1.909 1.992v15.657c0 1.1.855 1.992 1.91 1.992 1.054 0 1.908-.892 1.908-1.992V19.359c0-1.1-.854-1.992-1.909-1.992Zm-7.636 9.867c0-2.2-1.71-3.984-3.818-3.984-2.109 0-3.819 1.784-3.819 3.984v7.782c0 2.2 1.71 3.984 3.819 3.984 2.108 0 3.818-1.784 3.818-3.984v-7.782Zm-3.818-1.992c-1.055 0-1.91.892-1.91 1.992v7.782c0 1.1.855 1.992 1.91 1.992 1.054 0 1.909-.892 1.909-1.992v-7.782c0-1.1-.855-1.992-1.91-1.992ZM3 35.062c0-2.174 1.679-3.937 3.75-3.937h.136c2.071 0 3.75 1.763 3.75 3.938 0 2.174-1.679 3.937-3.75 3.937H6.75C4.679 39 3 37.237 3 35.062Z",
      clipRule: "evenodd"
    }
  )
);
var SvgNetwork1Outlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Network1Outlined_default = SvgNetwork1Outlined;

export { Network1Outlined_default as default };
